function normalizeReason(reason: string | undefined): string {
  return reason?.toLowerCase() ?? '';
}

export function isPromoNotFoundReason(reason: string | undefined): boolean {
  return normalizeReason(reason).includes('not found');
}

export function isPromoRedeemedReason(reason: string | undefined): boolean {
  return normalizeReason(reason).includes('redeemed');
}

export function isPromoDateInvalidReason(reason: string | undefined): boolean {
  return normalizeReason(reason).includes('not valid for selected order date');
}

export function isPromoNotActiveReason(reason: string | undefined): boolean {
  return normalizeReason(reason).includes('not active');
}

export function isStaticPromoInactiveReason(reason: string | undefined): boolean {
  return (
    isPromoNotFoundReason(reason) ||
    isPromoRedeemedReason(reason) ||
    isPromoNotActiveReason(reason) ||
    isPromoDateInvalidReason(reason)
  );
}

export function isPromoDefinitionHiddenReason(reason: string | undefined): boolean {
  return (
    isPromoNotFoundReason(reason) ||
    isPromoRedeemedReason(reason) ||
    isPromoDateInvalidReason(reason)
  );
}
